export const AMPLIFY_PROVIDER_STORAGE_KEY = 'amplify-provider';

export const SOCIAL_SIGN_IN_WAIT_MS = 1000;
